export const FETCH_REQUEST = 'AUTHENTICATION.FETCH_REQUEST';
export const FETCH_SUCCESS = 'AUTHENTICATION.FETCH_SUCCESS';
export const FETCH_FAILURE = 'AUTHENTICATION.FETCH_FAILURE';


// WEBPACK FOOTER //
// ./src/constants/Authentication.ts